import styled from "styled-components";

export const AmusnetWidgetLogoDefaultBox = styled.img`
    padding-block-start: 2rem;
    margin: 0 auto;
    min-height: 65px;
`;
